// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","about":"about_about__vAO+b","container":"about_container__HOEwm","aboutInner":"about_aboutInner__n9e8v","btns":"about_btns__QuDrT"};